import { Link } from 'react-router-dom';
import { useProgress } from '../hooks/useProgress';

export default function IntroPage() {
  const { ensureStarted, solvedCount, total, allDone } = useProgress();

  return (
    <main className="fh-page fh-page--intro">
      <div className="fh-atmosphere" aria-hidden="true" />
      <div className="fh-vignette" aria-hidden="true" />
      <div className="fh-panel fh-panel--intro">
        <p className="fh-eyebrow">Festa da História · Bragança</p>
        <h1 className="fh-brand">Cidadela</h1>
        <p className="fh-lede">
          O viajante do tempo esteve nas redondezas do Castelo de Bragança e
          parece ter deixado rasto.
        </p>
        <p className="fh-lede">
          Há relatos que documentos enigmáticos surgiram em vários pontos.
        </p>
        <p className="fh-lede">
          Investiga e descobre onde se encontra o esconderijo dele.
        </p>

        {allDone ? (
          <Link className="fh-btn fh-btn--primary" to="/festa-historia/mapa">
            Iniciar investigação
          </Link>
        ) : (
          <Link
            className="fh-btn fh-btn--primary"
            to="/festa-historia/mapa"
            onClick={() => ensureStarted()}
          >
            {solvedCount > 0 ? 'Continuar desafio' : 'Começar desafio'}
          </Link>
        )}

        {solvedCount > 0 && !allDone && (
          <p className="fh-progress-note">
            {solvedCount} de {total} locais resolvidos neste aparelho
          </p>
        )}
      </div>
    </main>
  );
}
